export const colors = {
  bg:              '#0a0a0a',
  surface:         '#111',
  surfaceAlt:      '#161616',
  surfaceHover:    '#1a1a1a',
  border:          '#1e1e1e',
  borderStrong:    '#2a2a2a',

  accent:          '#cc2200',
  accentHover:     '#aa1a00',
  accentDim:       '#cc220055',
  accentDark:      '#1a0800',
  accentDarkBorder:'#4a1a1a',

  green:           '#00e676',

  textPrimary:     '#fff',
  textSecondary:   '#ccc',
  textMuted:       '#999',
  textDim:         '#666',
  textFaint:       '#444',
  textPlaceholder: '#2e2e2e',
};

export const fonts = {
  display: "'Bebas Neue', sans-serif",
  body:    "'DM Sans', sans-serif",
};

export const radii = {
  sm: 4,
  md: 6,
  lg: 10,
  xl: 14,
};
